import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=bdec7ee4&scoped=true&"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=js&"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=bdec7ee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec7ee4",
  null
  
)

export default component.exports